import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';

import { SpinnerService } from '@shared/services/spinner/spinner.service';
import { CustomHttpHeaders } from '@core/configurations/custom-http-headers.config';

export const LoadingInterceptor: HttpInterceptorFn = (
  httpRequest,
  httpHandler,
) => {
  const spinnerService = inject(SpinnerService);

  const skipLoader = httpRequest.headers.get(CustomHttpHeaders.SkipSpinner);

  if (skipLoader) {
    const requestWithoutHeader = httpRequest.clone({
      headers: httpRequest.headers.delete(CustomHttpHeaders.SkipSpinner),
    });
    return httpHandler(requestWithoutHeader);
  }

  spinnerService.turnOn();

  return httpHandler(httpRequest).pipe(
    finalize(() => {
      spinnerService.turnOff();
    }),
  );
};
